module.exports = __webpack_public_path__ + "media/images/premium/premium-kaishi-title-1ea2c1b8152eb73a42781c53221fe911.svg";